import ApiFetch from "../components/ApiFetch";

// カレンダーメモAPI呼び出し用サービス
const API_BASE = ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+'/v1/calendarMemo';

export async function fetchMemos(date) {
  const res = await fetch(`${API_BASE}/list?date=${encodeURIComponent(date)}`, {
    credentials: 'include',
  });
  if (!res.ok) throw new Error('メモ取得に失敗しました');
  return await res.json();
}

export async function addMemo(date, title, text) {
  const res = await fetch(`${API_BASE}/add`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ date, title, text })
  });
  if (!res.ok) throw new Error('メモ追加に失敗しました');
  return await res.json();
}

export async function updateMemo(id, title, text) {
  const res = await fetch(`${API_BASE}/update/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ title, text })
  });
  if (!res.ok) throw new Error('メモ更新に失敗しました');
  return await res.json();
}

export async function deleteMemo(id) {
  const res = await fetch(`${API_BASE}/delete/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok) throw new Error('メモ削除に失敗しました');
  return await res.json();
}

export async function fetchMonthMemoCounts(year, month) {
  const res = await fetch(`${API_BASE}/month-counts?year=${year}&month=${month}`, {
    credentials: 'include',
  });
  if (!res.ok) throw new Error('月のメモ数取得に失敗しました');
  return await res.json();
}
